import { knownDotcomUrls } from '@sola/my-sdk/constants.ts';

import type { AppealMetadata } from '../../../types/notifications.ts';

export const giveThanksAppealTranslationKey =
  'notifications:messages.appeal.giveThanks';

export const giveThanksAppealMetadata: AppealMetadata = {
  id: 'give-thanks',
  startMonthDay: '11-09',
  endMonthDay: '11-24',
  href: knownDotcomUrls.catalog,
  titleTranslationKey: `${giveThanksAppealTranslationKey}.title`,
  descriptionTranslationKey: `${giveThanksAppealTranslationKey}.description`,
  iconName: 'heart-hand',
};

export const christmasGiftCatalogAppealTranslationKey =
  'notifications:messages.appeal.christmasGiftCatalog';

export const christmasGiftCatalogAppealMetadata: AppealMetadata = {
  id: 'christmas-gift-catalog',
  startMonthDay: '11-30',
  endMonthDay: '12-14',
  href: knownDotcomUrls.catalog,
  titleTranslationKey: `${christmasGiftCatalogAppealTranslationKey}.title`,
  descriptionTranslationKey: `${christmasGiftCatalogAppealTranslationKey}.description`,
  iconName: 'christmas-gift',
};
